module.exports = __webpack_public_path__ + "img/bus-fill-blue.3586a45d.svg";